export enum ListingSkuStatusNamesEnum {
  active = 'Active',
  pending = 'Pending',
  inactive = 'Inactive',
  soldOut = 'Sold Out',
  paused = 'Paused',
  removed = 'Removed',
  archived = 'Archived'
}


// These values mirror the API's SkuStatus enum positionally and are posted back as
// the grid filter and as the export options, so pending is APPENDED (7) to match the member added
// on the server. Its position here is the wire value, not the order it is displayed in - the
// Product Listings strip shows it between Active and Inactive, ordered by TAB_DISPLAY in listing-page.rules.
export enum ListingSkuStatusValuesEnum {
  all,
  active,
  inactive,
  soldOut,
  paused,
  removed,
  archived,
  pending
}
